import React, { FunctionComponent, useContext } from "react"
import {
  Dialog,
  Grid,
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  useTheme,
} from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { useTranslation } from "react-i18next"
import { useCollectionPointsFilter } from "../../../../../context/CollectionPointsFilterContext"
import { CollectionPointsExportContext } from "./collection-points-export-context"

interface ICollectionPointsExportDialogProps {}

export const CollectionPointsExportDialog: FunctionComponent<ICollectionPointsExportDialogProps> = (props) => {
  const { t } = useTranslation()
  const { isFilterSet } = useCollectionPointsFilter()
  const theme = useTheme()

  const {
    setDialogOpen,
    dialogOpen,
    exportLoading,
    onExportConfirmed,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    resetValues,
    forecastEnabled,
    useFilter,
    setUseFilter,
  } = useContext(CollectionPointsExportContext)

  const handleClose = () => {
    resetValues()
    setDialogOpen(false)
  }

  return (
    <Dialog open={dialogOpen} onClose={handleClose}>
      <DialogTitle>{t("collection_points.export_dialog.title")}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ p: 1 }}>
          <Grid item>
            <DatePicker
              label={t("date_picker.from")}
              format={t("date_format")}
              value={startDate}
              onChange={(dateTime: moment.Moment | null) => {
                if (dateTime) {
                  setStartDate(dateTime.utc(true).startOf("day"))
                }
              }}
              maxDate={endDate}
              disabled={exportLoading}
              slotProps={{
                textField: {
                  size: "small",
                },
              }}
            />
          </Grid>
          <Grid item>
            <DatePicker
              label={t("date_picker.to")}
              format={t("date_format")}
              value={endDate}
              onChange={(dateTime: moment.Moment | null) => {
                if (dateTime) {
                  setEndDate(dateTime.utc(true).endOf("day"))
                }
              }}
              minDate={startDate}
              disabled={exportLoading || !forecastEnabled}
              slotProps={{
                textField: {
                  size: "small",
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container item xs={12} spacing={2} justifyContent="space-between">
          <Grid item>
            {isFilterSet && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={useFilter}
                    onChange={(event) => setUseFilter(event.target.checked)}
                    name="use-filter"
                    color="primary"
                    style={{
                      color: theme.palette.primary.light,
                      padding: `0 ${theme.spacing(1)}`,
                    }}
                  />
                }
                label={t("collection_points.export_dialog.filter")}
              />
            )}
          </Grid>
          <Grid item>
            <Button onClick={handleClose} color="inherit" disabled={exportLoading}>
              {t("cancel")}
            </Button>
            <Button
              onClick={() => onExportConfirmed(startDate, endDate, useFilter)}
              color="primary"
              autoFocus
              disabled={!startDate.isValid() || !endDate.isValid() || startDate.isAfter(endDate) || exportLoading}
            >
              {t("collection_points.export_dialog.export")}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  )
}
